/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const FlexiPoints = (props) => {
  return (
    <BaseSvgIcon {...props} viewBox="0 0 30 30">
      <defs>
        <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-1">
          <stop stopColor="#C140AF" offset="0%" />
          <stop stopColor="#52489C" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="0%" x2="100%" y2="100%" id="linearGradient-2">
          <stop stopColor="#52489C" offset="0%" />
          <stop stopColor="#C140AF" offset="100%" />
        </linearGradient>
      </defs>
      <g id="2.0-(flexi-points)" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="FLEXI_iteration_wallet" transform="translate(-762.000000, -472.000000)" fillRule="nonzero">
          <g id="flexi_point" transform="translate(762.000000, 472.000000)">
            <circle id="Oval-Copy-8" fill="url(#linearGradient-1)" cx="15" cy="15" r="15" />
            <circle id="path-3" fill="url(#linearGradient-2)" transform="translate(15.000000, 15.000000) rotate(90.000000) translate(-15.000000, -15.000000) " cx="15" cy="15" r="12" />
            <path d="M15.4714714,8.39592278 L16.6988996,12.0670839 C16.7774916,12.3033797 17.0041194,12.4632666 17.2595433,12.4632666 L21.2305184,12.4632666 C21.8019737,12.4632666 22.0395169,13.1738172 21.5773211,13.5002443 L18.3645094,15.7692244 C18.1580495,15.9151809 18.0715567,16.1738276 18.1502526,16.4101234 L19.3774729,20.0812845 C19.553993,20.6093895 18.9322222,21.0486106 18.4701304,20.7221835 L15.2572147,18.4532035 C15.0505468,18.3072469 14.7706928,18.3072469 14.5643368,18.4532035 L11.3515251,20.7221835 C10.8893293,21.0486106 10.2675585,20.6093895 10.4439746,20.0812845 L11.670987,16.4101234 C11.7499948,16.1738276 11.6635021,15.9151809 11.4567303,15.7692244 L8.24423038,13.5002443 C7.78203459,13.1738172 8.01957786,12.4632666 8.5909292,12.4632666 L12.5616963,12.4632666 C12.8171203,12.4632666 13.043748,12.3033797 13.1227558,12.0670839 L14.3497682,8.39592278 C14.5264962,7.86802574 15.2950553,7.86802574 15.4714714,8.39592278" id="Fill-15" fill="#FFFFFF" />
          </g>
        </g>
      </g>
    </BaseSvgIcon>
  )
}

export default FlexiPoints
